const searchItemsData = [
    {
        id: 5,
        title: 'Public',
        key: 'locked_date',
        content: [
            {
                field: 'Yes',
                checked: 'checked',
            },
            {
                field: 'No',
                checked: 'checked',
            },
        ],
    },
    {
        id: 4,
        title: 'Popular',
        key: 'is_popular',
        content: [
            {
                field: 'Yes',
                checked: 'checked',
            },
            {
                field: 'No',
                checked: 'checked',
            },
        ],
    },
    {
        id: 1,
        title: 'Status',
        key: 'is_available',
        content: [
            {
                field: 'Available',
                checked: 'checked',
            },
            {
                field: 'Locked',
                checked: 'checked',
            },
        ],
    },
    {
        id: 2,
        title: 'Tags',
        content: [
            {
                field: 'Any',
                checked: 'checked',
            },
            {
                field: 'Minimal Wear',
            },
            {
                field: 'Factory New',
            },
            {
                field: 'Field-Tested',
            },
            {
                field: 'Well-Worn',
            },
            {
                field: 'Battle-Scarred',
            },
        ],
    },
    {
        id: 3,
        title: 'Phase',
        content: [
            {
                field: 'Any',
                checked: 'checked',
            },
            {
                field: 'Phase 1',
            },
            {
                field: 'Phase 2',
            },
            {
                field: 'Phase 3',
            },
            {
                field: 'Phase 4',
            },
            {
                field: 'Sapphire',
            },
            {
                field: 'Ruby',
            },
            {
                field: 'Black Pearl',
            },
            {
                field: 'Emerald',
            },
        ],
    },
]

export default searchItemsData
